export const routes = {
  root: () => '/[businessUnit]',
  password: () => '/[businessUnit]/password',
  mfa: () => '/[businessUnit]/mfa',
  username: () => '/[businessUnit]/username',
  setupMfa: () => '/[businessUnit]/setup-mfa',
  contactEmail: () => '/[businessUnit]/contact-email',
  logout: () => '/auth/signout',
  email: () => '/[businessUnit]/email',
};
